import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { mdiArrowLeft } from '@mdi/js'
import { Organization } from '@/modules/Organizations/types'
import { fetchOrganization, updateOrganization } from '@/enitites/organization/api/endpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsPage',
  setup(__props) {

const org = ref<Organization>()
const isLoading = ref(false)

const route = useRoute()
const router = useRouter()

const currentRoute = computed(() => route.matched.find((routeItem) => routeItem.parent))
const childRoutes = computed(
  () => router.options.routes?.find((item) => item.name === 'OrganizationSettings')?.children || []
)

onMounted(async () => {
  org.value = await fetchOrganization(route.params.id)
  if (!org.value) {
    await router.push({ name: 'Organizations' })
  }
})

async function updateOrg() {
  if (!org.value) return
  isLoading.value = true
  const resp = await updateOrganization(org.value)
  if (resp) {
    await store.dispatch('showAlertToast', 'changesSaved')
  }
  isLoading.value = false
}

return { __sfc: true,org, isLoading, route, router, currentRoute, childRoutes, updateOrg, mdiArrowLeft }
}

})